module.exports = __webpack_public_path__ + "static/img/pay-en-0.19e1bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/en/pay-en-0.png
// module id = HZwP
// module chunks = 0